import React from 'react'
import PropTypes from 'prop-types'

import About from './About'
import PlanHeader from './PlanHeader'
import HeroCarousel from './Hero'
import Recommended from './Recommended'

import { GridItem, HR, MainContainer, PromoBanner, Space } from 'ui/acro'

const mobileAreas = `
  '. header .'
  'hero hero hero'
  '. about .'
  'recommended recommended recommended'
`

// Mobile and Tablet areas are the same for now until we settle on breakpoint sizes and set tablet designs.
const tabletAreas = mobileAreas

const deskAreas = `
'hero header'
'hero about'
'recommended recommended'
`

const gridTemplateAreas = [mobileAreas, tabletAreas, deskAreas]

const PlanLayout = ({ plan }) => {
  return (
    <React.Fragment>
      <MainContainer
        gridTemplateAreas={gridTemplateAreas}
        gridColumnGap={[null, null, '50px']}
      >
        <GridItem area='hero' pb={['29px', null, '0px']}>
          <HeroCarousel planId={plan.id} previewMedia={plan.previewMedia} />
        </GridItem>
        <GridItem area='header' pb={['16px', null, '28px']}>
          <PlanHeader plan={plan} area='header' />
        </GridItem>
        <GridItem area='about'>
          <About
            description={plan.description}
            benefits={plan.benefitsList}
            planId={plan.id}
          />
        </GridItem>
        <GridItem area='recommended'>
          <HR mt={['60px', null, '90px']} mb={['16px', null, '28px']} />
          <Recommended planId={plan.id} />
          <Space pb={['55px', null, '93px']} />
        </GridItem>
      </MainContainer>
      <PromoBanner
        title='WANT FREE ACCESS?'
        body='Unlimited workouts and wellness are only one tap away. Sign up now for instant access.'
        btnText='Learn More'
        btnLink='/'
        productId={plan.id}
        cta={'START YOUR FREE TRIAL'}
        id='plan'
      />
    </React.Fragment>
  )
}

PlanLayout.propTypes = {
  plan: PropTypes.object.isRequired
}

export default PlanLayout
